import { useCallback } from 'react';
import { useModalMethods } from '../../shared/packages/modalManager';
import { modalNames } from '../../shared/configs/modal';

export const useOpenAddTenantModal = () => {
  const { open } = useModalMethods();

  return useCallback(
    (props) => {
      open(modalNames.addTenant, props);
    },
    [open]
  );
};
